<template lang="pug">
.input-checkbox
    label.input-label-checkbox {{ label }}
    checkbox-input-component(
        v-for='(item, index) in list',
        @click='toggle(item)',
        v-model='list[index]',
        :mostrar-nome='true',
        :key='index'
    )
</template>

<script>
export default {
    name: 'CheckboxGroupInputComponent',
    props: {
        value: {
            type: Array,
            required: true,
        },
        label: {
            type: String,
            default: '',
        },
        list: {
            type: Array,
            required: true,
        },
    },

    methods: {
        toggle(item) {
            if (item.selecionado) {
                this.value.push(item);
            } else {
                const index = this.value.indexOf(item);
                if (index >= 0) {
                    this.value.splice(index, 1);
                }
            }
            this.$emit('input', this.value);
        },
    },
};
</script>
